<template>
  <div class="exhibitionManageBox">
    <vab-query-form class="ml-10" style="padding-top: 20px">
      <vab-query-form-left-panel :span="24">
        <el-form :inline="true" :model="state.queryForm" @submit.prevent>
          <el-form-item label="会议名称">
            <el-input v-model="state.queryForm.meetingName" class="mr-10" clearable placeholder="请输入会议名称" />
          </el-form-item>
          <el-form-item label="会议Code">
            <el-input v-model="state.queryForm.code" class="mr-10" clearable placeholder="请输入会议Code" />
          </el-form-item>
          <el-form-item label="创建人">
            <el-input v-model="state.queryForm.hostName" class="mr-10" clearable placeholder="请输入创建人姓名" />
          </el-form-item>
          <el-form-item label="会议时间">
            <el-date-picker
              v-model="state.queryForm.dateRange"
              class="mr-10"
              clearable
              end-placeholder="结束日期"
              format="YYYY-MM-DD"
              start-placeholder="开始日期"
              type="daterange"
              value-format="YYYY-MM-DD HH:mm:ss"
              @change="handleDateRangeChange"
            />
          </el-form-item>
          <el-form-item label="排序">
            <el-select v-model="state.queryForm.orderDirection" class="mr-10" style="width: 110px">
              <el-option label="开始时间倒序" value="desc" />
              <el-option label="开始时间升序" value="asc" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button icon="Search" type="primary" @click="handleQueryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-left-panel>
    </vab-query-form>

    <el-row :gutter="10">
      <el-col v-for="(item, index) in state.list" :key="index" :lg="8" :md="24" :sm="24" :xl="6" :xs="24">
        <div class="box-card">
          <div class="title">
            <div class="name">{{ item.meetingName }}</div>
            <el-icon v-if="hasPermission(['exhibition:edit'])" class="editIcon" @click="handleEdit(item)">
              <Edit />
            </el-icon>
          </div>
          <div class="form">
            <div class="form-item">
              <div class="label">会议状态</div>
              <div class="item">
                <div v-if="item.status == 'PUBLISHED'" class="yishangjia iconbox">已发布</div>
                <div v-else class="yixiajia iconbox">草稿</div>
              </div>
            </div>
            <div class="form-item">
              <div class="label">会议开始时间</div>
              <div class="item">
                {{ item.startTime ? filterTime(item.startTime) : '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">会议结束时间</div>
              <div class="item">
                {{ item.endTime ? filterTime(item.endTime) : '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">创建人姓名</div>
              <div class="item">
                {{ item.hostName ? item.hostName : '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">创建人手机号</div>
              <div class="item">
                {{ item.hostPhone || item.phone || '暂无' }}
              </div>
            </div>
            <div class="form-item">
              <div class="label">会议Code</div>
              <div class="item">
                {{ item.meetingCode }}
              </div>
            </div>
          </div>
          <div class="controllBox">
            <el-button type="primary" @click="goAppManage(item)">进入管理</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      v-if="state.total > 9"
      background
      :current-page="state.queryForm.pageNum"
      :layout="state.layout"
      :page-size="state.queryForm.pageSize"
      :total="state.total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <!-- 编辑 -->
    <edit-com-meet ref="refExDialog" @noticeRefresh="getData" />
  </div>
</template>
<script>
  export default {
    name: 'ExhibitionManage',
  }
</script>
<script setup>
  import { onActivated, reactive, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import { useComponent } from './components/index'
  import { Edit } from '@element-plus/icons'
  import { getAllHoldMeetingManageList } from '@/api/exhibitionManage'
  import { debounce } from '@/utils/debounce'
  import { parseTime } from '@/utils/index'
  import { hasPermission } from '@/utils/permission'

  // 引入组件
  const { editComMeet } = useComponent()
  const router = useRouter()
  const refExDialog = ref(null) // 编辑弹框
  const loading = ref(false) // 列表动画加载

  const filterTime = (val) => {
    return val ? parseTime(val) : '暂无'
  }

  const state = reactive({
    queryForm: {
      meetingName: '',
      code: '',
      hostName: '',
      dateRange: [],
      startTime: '',
      endTime: '',
      orderDirection: 'desc',
      pageNum: 1,
      pageSize: 12,
    },
    collapseItem: 0,
    total: 0,
    layout: 'prev, pager, next',
    list: [],
  })

  const handleDateRangeChange = (val) => {
    if (val && val.length === 2) {
      state.queryForm.startTime = val[0]
      state.queryForm.endTime = val[1]
    } else {
      state.queryForm.startTime = ''
      state.queryForm.endTime = ''
    }
  }

  const getData = async () => {
    loading.value = true
    const { data } = await getAllHoldMeetingManageList(state.queryForm)
    state.list = data.data
    state.total = data.total || 0
    setTimeout(() => {
      loading.value = false
    }, 500)
  }

  // 进入会议管理中间页
  const goAppManage = (row) => {
    router.push({
      path: '/exhibitionManage/meetingAppManage',
      query: {
        meetingCode: row.meetingCode,
        meetingName: row.meetingName,
        isOpenAiAbstractSentence: row.isOpenAiAbstractSentence,
      },
    })
  }

  // 查询
  const handleQueryData = debounce(() => {
    state.queryForm.pageNum = 1
    state.collapseItem = 0
    getData()
  })

  // 编辑
  const handleEdit = (row) => {
    refExDialog.value.handleOpen({ ...row })
  }
  // 条数
  const handleSizeChange = debounce((pageSize) => {
    state.queryForm.pageSize = pageSize
    state.collapseItem = 0
    getData()
  })
  // 页码
  const handleCurrentChange = debounce((pageNum) => {
    state.queryForm.pageNum = pageNum
    state.collapseItem = 0
    getData()
  })

  // 挂载
  onActivated(() => {
    getData()
  })
</script>

<style lang="scss" scoped>
  .exhibitionManageBox {
    background: #f5f5f5;
    height: 80vh;
  }

  .collapseTitle {
    font-size: 16px;
  }

  .el-descriptions__label {
    font-size: 14px;
  }

  .box-card {
    cursor: pointer;
    min-height: 253px;
    background: #fff;
    border-radius: 12px;
    padding: 0 12px 20px 12px;
    margin-bottom: 10px;

    // max-width: 500px;
    .title {
      height: 45px;
      line-height: 45px;
      font-size: 16px;
      font-weight: 500;
      color: #000000;
      border-bottom: 1px solid #f5f5f5;
      display: flex;
      justify-content: space-between;

      .editIcon {
        font-size: 20px;
        line-height: 55px;
        color: #409eff;
      }

      .name {
        width: calc(100% - 30px);
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
      }
    }

    .form {
      padding: 10px 0;
      border-bottom: 1px solid #f5f5f5;

      .form-item {
        display: flex;
        margin-top: 8px;

        .label {
          width: 30%;
          font-size: 12px;
          font-weight: 400;
          color: #909499;
        }

        .item {
          .iconbox {
            font-size: 10px;
            font-weight: 400;
          }

          .yishangjia {
            width: 60px;
            height: 17px;
            line-height: 17px;
            background: #e7faf0;
            border-radius: 2px;
            border: 1px solid #d0f5e0;
            color: #21cf6b;
            position: relative;
            padding-left: 13px;

            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: 6px;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #21cf6b;
              border-radius: 50%;
            }
          }

          .yixiajia {
            width: 60px;
            height: 17px;
            line-height: 17px;
            background: #feeded;
            border-radius: 2px;
            border: 1px solid #ffdbdd;
            color: #ff5153;
            position: relative;
            padding-left: 13px;

            &::before {
              content: '';
              position: absolute;
              top: 50%;
              left: 6px;
              transform: translateY(-50%);
              width: 5px;
              height: 5px;
              background: #ff5153;
              border-radius: 50%;
            }
          }
        }
      }
    }

    .controllBox {
      display: flex;
      justify-content: right;
      align-items: center;
      margin-top: 10px;
    }
  }

  .card-header {
    display: flex;
    justify-content: space-between;
  }
</style>
